import type {IFetchContext} from "@pg-mono/data-fetcher";
import {consoleError} from "@pg-mono/logger";

import type {IRPStore} from "../../../app/rp_reducer";
import type {IRPRequestMeta} from "../../../app/rp_request_meta";
import {disableServerCache} from "../../../app/state/server_cache_slice";
import {getOfferList} from "../../../offer/api/get_offer_list";
import type {IGetOfferListPayload} from "../../../offer/types/GetOfferListPayload";
import {OfferType} from "../../../offer/types/OfferType";
import {IAppDispatch} from "../../../store/store";
import {getPricesHubOffersQuery, getPricesRegionOffersQuery} from "../utils/get_prices_offers_query";

// The carousel retries a failed list in the browser, so a miss never blocks the page - it only keeps the
// offer-less HTML out of the page cache.
const prefetchOfferList = async (dispatch: IAppDispatch, query: IGetOfferListPayload) => {
    try {
        await dispatch(getOfferList.endpoints.getOfferList.initiate(query)).unwrap();
    } catch (error) {
        consoleError("prefetchOfferList error: ", error);
        dispatch(disableServerCache());
    }

    return true;
};

// Default state of the hub carousel - the "Wszystkie" pill.
export const fetchPricesHubOffers = (_ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: IAppDispatch) =>
    prefetchOfferList(dispatch, getPricesHubOffersQuery(null));

// Default state of the city and address carousels - the whole city, "Wszystkie dzielnice". Both pages are flats only.
export const fetchPricesRegionOffers = (_ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: IAppDispatch, getState: () => IRPStore) => {
    const {district, region} = getState().report.price;
    const offersRegion = district ?? region;

    if (!offersRegion) {
        return true;
    }

    return prefetchOfferList(dispatch, getPricesRegionOffersQuery(offersRegion.id, OfferType.FLAT));
};
import type {IFetchContext} from "@pg-mono/data-fetcher";
import {consoleError} from "@pg-mono/logger";

import type {IRPStore} from "../../../app/rp_reducer";
import type {IRPRequestMeta} from "../../../app/rp_request_meta";
import {disableServerCache} from "../../../app/state/server_cache_slice";
import {getOfferList} from "../../../offer/api/get_offer_list";
import type {IGetOfferListPayload} from "../../../offer/types/GetOfferListPayload";
import {OfferType} from "../../../offer/types/OfferType";
import {IAppDispatch} from "../../../store/store";
import {getPricesHubOffersQuery, getPricesRegionOffersQuery} from "../utils/get_prices_offers_query";

// The carousel retries a failed list in the browser, so a miss never blocks the page - it only keeps the
// offer-less HTML out of the page cache.
const prefetchOfferList = async (dispatch: IAppDispatch, query: IGetOfferListPayload) => {
    try {
        await dispatch(getOfferList.endpoints.getOfferList.initiate(query)).unwrap();
    } catch (error) {
        consoleError("prefetchOfferList error: ", error);
        dispatch(disableServerCache());
    }

    return true;
};

// Default state of the hub carousel - the "Wszystkie" pill.
export const fetchPricesHubOffers = (_ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: IAppDispatch) =>
    prefetchOfferList(dispatch, getPricesHubOffersQuery(null));

// Default state of the city and address carousels - the whole city, "Wszystkie dzielnice". Both pages are flats only.
export const fetchPricesRegionOffers = (_ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: IAppDispatch, getState: () => IRPStore) => {
    const {district, region} = getState().report.price;
    const offersRegion = district ?? region;

    if (!offersRegion) {
        return true;
    }

    return prefetchOfferList(dispatch, getPricesRegionOffersQuery(offersRegion.id, OfferType.FLAT));
};
